import React, {useState} from "react";
import ErrorIcon from '@mui/icons-material/Error';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import Button from '@mui/material/Button';

export const Message = (props) =>{
    const errorMessage = 'Something went wrong!';
    const successMessage = 'Payment Successful';
    const [open, setOpen] = useState(props.open);
    const handleClose = () => setOpen(false);

    return(
    <>
    <Modal
        open={open}
        //onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="checkInvoiceBox"
    >
        <Box sx={props.style}>
            <Typography id="modal-modal-description" sx={{ mt: 2, mb:2 }} textAlign="center">
                {props.icon ? <CheckCircleRoundedIcon sx={{ fontSize: 60 }} color="success" /> : <ErrorIcon sx={{ fontSize: 60 }} color="error" /> }
            </Typography>
            <Typography id="modal-modal-title" variant="h5" component="h2" alignItems="center" textAlign="center" color={props.color} sx={{ mb:3 }} >
                    {props.success ? successMessage : errorMessage}
            </Typography>
            <Typography id="modal-modal-title" variant="body1" component="h2" alignItems="center" textAlign="center" sx={{mb:4}}>
                {props.message}
            </Typography>
            <Box textAlign="center" alignItems="center" justifyContent="center" sx={{mt:2}}>
              {props.success ? '' : <Button variant="contained" onClick={handleClose}>Try Again</Button>}
            </Box>
        </Box>
    </Modal>
    </>
    )
    
}